const tables = [
  {
    name: "Number",
  },
  {
    name: "Sales Order",
  },
  {
    name: "Customer",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Total",
  },
  {
    name: "Action",
  },
];

export default tables;